var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Config")]),_c('div',{staticClass:"ava"}),_c('div',{staticClass:"table"},_vm._l((_vm.dataTable),function(row){return _c('div',{staticClass:"row"},[_c('small',[_vm._v(_vm._s(row.field))]),_c('p',[_vm._v(_vm._s(row.value))])])}),0),_c('hr')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62b717e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Config.vue
// module id = va9f
// module chunks = 0